
const enum ContractType {
    'Standard',
    'None'

};

const enum EnergyPriceType {
    'Null',
    'ContractUnchanged',
    'None',
    'Low',
    'Normal',
    'Special',
    'Unknown',
    'ContractDivergentNone'
};

const enum MarketdateBoothStatus {
    'None',
    'Absent',
    'Completed'

};
import { Salesunit } from '../salesunit';
import { Contact } from '../contact';
import { Contract } from '../contract';
import { Marketdate } from '../marketdate';
import { User } from '../../shared';
export class MarketdateBooth {
    constructor(
        public id?: number,
        public contractType?: ContractType,
        public order?: number,
        public width?: number,
        public depth?: number,
        public sqmCost?: number,
        public sqmCostIncludingBase?: number,
        public energyPriceType?: EnergyPriceType,
        public priceSanitary?: number,
        public priceCleaning?: number,
        public priceParking?: number,
        public marketingFee?: number,
        public priceTotal?: number,
        public status?: MarketdateBoothStatus,
        public correctionNotice?: string,
        public salesunit?: Salesunit,
        public contactPerson?: Contact,
        public contract?: Contract,
        public marketdate?: Marketdate,
        public updatedBy?: User,
        public merchant?: Contact,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketdate-booth/marketdate-booth.model.ts